import React from 'react';
import logo from '../assets/img/logo.png';
export default class Footer extends React.Component {
  constructor() {
    super();
    this.state = {footerMenu:[]};
  }
  getFooterMenu=()=>{
    fetch('https://srkbst.org/data/footerMenu.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        } 
        return response.json();
      })
      .then(data => {
        this.setState({footerMenu:data})
        console.log('Fetched data:', data);
        // You can now use the data in your component state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      }); 
  }
  componentDidMount(){
    this.getFooterMenu()
  }
  render() {
    return <>
    <div
      className="container-fluid bg-dark footer pt-2 p-0 wow fadeIn"
      data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="row g-3">
           <div className='col-12 col-md-4 col-lg-2  no-border-sm-xs text-center'>
             <img src={'https://srkbst.org/assets/home/shankaracharya.png'} style={{width:"150px"}}/> 
           </div>
          <div className="col-12 col-md-8 col-lg-4 text-center no-border-sm-xs">
            <img src={'https://srkbst.org/assets/home/footerlogo.png'} style={{width:"150px"}}/>           
            
          <h5 className="text-white mb-4"> Sree Ramakrishna <br/>Bhajana Sabha Trust (Regd.) <br/>
          <small className="fs-7 text-white me-2">Uplifting Spirits, Serving Society.</small>
          </h5>
          
          </div>
          <div className="col-12 col-md-6 col-lg-2  no-border-sm-xs d-none d-sm-block d-md-block d-lg-block d-xl-block">
                       
            {this.state.footerMenu.length>0 && this.state.footerMenu.map((item,index)=>{
              
              return(
               <a key={index} className="col-lg-12 btn btn-link text-start text-white text-decoration-none" href={item.link}>{item.name}</a>
               
              )
            })}            
            
           
          </div>
          <div className="col-12 col-md-6 col-lg-2 no-border-sm-xs d-block d-sm-none">
           
            <ul className='float-start'>
             
            {this.state.footerMenu.length>0 && this.state.footerMenu.map((item,index)=>{
              
                return(
                  <li key={index} style={{listStyleType:"none"}}><a  className="col-lg-12 btn btn-link text-start text-white text-decoration-none" href={item.link}>{item.name}</a></li>
                 
                )
              
             
            })}            
             </ul>
             {/* <ul className='float-start'>
             {this.state.footerMenu.length>0 && this.state.footerMenu.map((item,index)=>{
              if(index>3){
                return(
                  <li key={index} style={{listStyleType:"none"}}><a className="col-lg-12 btn btn-link text-start text-white text-decoration-none" href={item.link}>{item.name}</a></li>
                 
                )
              }
             
            })} 
             </ul> */}
           
          </div>
          <div className="col-12 col-md-6 col-lg-4  text-white pt-lg-5">
            <h5 className="text-light mb-4 ms-3 text-center">Contact Us</h5>
            <p className='text-center'>
              “Shiva Krupa” # 15, Damodara Mudaliyar Street, <br/>Halasuru, Bengaluru-560008.
            </p>
            <p className='text-center'>Mob: 988011024 / 8618994721 / 9900793536 /  9854812545</p>
            <p className='text-center'><a href="mailto:srkbst1951@gmail.com" className="text-decoration-underline text-white">Email: srkbst1951@gmail.com</a></p>
            <p className="text-center">
              <a href="/privacy-policy" className="text-decoration-underline text-white me-2">Privacy Policy</a>
              <span className="text-white mx-2">|</span>
              <a href="/terms-and-conditions" className="text-decoration-underline text-white ms-2">Terms and Conditions</a>
            </p>
          </div>
        </div>
      </div>
     
      <div className="container-fluid copyright bg-white ">
        <div className="container">
          <div className="row">
            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
              &copy; <a href="#">2025 by Sree Ramakrishna Bhajana Sabha Trust</a>, All Right Reserved.
            </div>
            
          </div>
        </div>
      </div>
    </div>
    </>;
  }
}